import React from 'react';
import Datetime from 'react-datetime';
import Moment from 'moment';
import MomentRu from 'moment/locale/ru';
import Store from '../library/M2Store';


import { SOURCES } from '../config';

function detectmob() {
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        return true;
    }
    else {
        return false;
    }
}

class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.show_sources = true;
        let sources = [];
        if(Store.get('m2filter_sources')) {
            let items = JSON.parse(Store.get('m2filter_sources'));
            if(items.length > 0) {
                this.show_sources = false;
                sources = items;
            }
        }
        this.state = {
            search_string: '',
            date_start: '',
            date_end: '',
            sources: sources,
            mobile: detectmob()
        };



    }



    changeSearchHandler(event) {
        this.setState({search_string: event.target.value});
    }

    __changeDateStart(event) {
        if(event._d) {
            this.setState({date_start: event._d});
            this.props.onSearch({
                search: this.state.search_string,
                sources: this.state.sources.join(','),
                date_start: event._d,
                date_end: this.state.date_end
            });
        } else {
            if(event && event.target && event.target.value) {
                this.setState({date_start: event.target.value});
                this.props.onSearch({
                    search: this.state.search_string,
                    sources: this.state.sources.join(','),
                    date_start: event.target.value,
                    date_end: this.state.date_end
                });
            } else {
                this.setState({date_start: ''});
                this.props.onSearch({
                    search: this.state.search_string,
                    sources: this.state.sources.join(','),
                    date_start: '',
                    date_end: this.state.date_end
                });
            }
        }
    }

    __changeDateEnd(event) {
        if(event._d) {
            this.setState({date_end: event._d});
            this.props.onSearch({
                search: this.state.search_string,
                sources: this.state.sources.join(','),
                date_end: event._d,
                date_start: this.state.date_start
            });
        } else {
            if(event && event.target && event.target.value) {
                this.setState({date_end: event.target.value});
                this.props.onSearch({
                    search: this.state.search_string,
                    sources: this.state.sources.join(','),
                    date_end: event.target.value,
                    date_start: this.state.date_start
                });
            } else {
                this.setState({date_end: ''});
                this.props.onSearch({
                    search: this.state.search_string,
                    sources: this.state.sources.join(','),
                    date_end: '',
                    date_start: this.state.date_start
                });
            }
        }
    }

    __submitHandler(event) {
        if(event.keyCode == 13) {
            this.props.onSearch({
                search: this.state.search_string,
                sources: this.state.sources,
                date_start: this.state.date_start,
                date_end: this.state.date_end
            });
        }
    }

    __submitHandlerForm(event) {
        event.preventDefault();
        this.props.onSearch({
            search: this.state.search_string,
            sources: this.state.sources,
            date_start: this.state.date_start,
            date_end: this.state.date_end
        });
    }

    selectSource(event) {
        let value = event.target.value;
        let sources = this.state.sources;
        if(sources.indexOf(value) + 1 > 0) {
            sources.splice(sources.indexOf(value), 1);
        } else {
            sources.push(value);
        }

        this.props.onSearch({
            search: this.state.search_string,
            sources: sources.join(','),
            date_start: this.state.date_start,
            date_end: this.state.date_end
        });

        this.setState({sources: sources});
    }

    render() {
        let items_first = [];
        let items_second = [];

        let self = this;
        SOURCES.map(function(item) {

                items_first.push(
                    <div key={item} className="m2checkbox">
                        <label>
                        <span className="m2checbox_input">
                            <input type="checkbox" value={item} onChange={self.selectSource.bind(self)}/>
                        </span>
                            {item}
                        </label>
                    </div>
                );

        });


        return (
            <div className="m2filter">
                <form method="POST" onSubmit={this.__submitHandlerForm.bind(this)}>
                    <div className="m2filter__row search__row">
                        <div className="m2filter__search">
                            <label htmlFor="search_input">Поиск </label>
                            <input onKeyDown={this.__submitHandler.bind(this)} id="search_input" type="text" name="search" value={this.state.search_string} onChange={this.changeSearchHandler.bind(this)} />

                        </div>
                        <div className="m2filter__dates">
                            <div className="m2date_input">
                                <label>С </label>
                                {!this.state.mobile ? <Datetime value={this.state.date_start} onChange={this.__changeDateStart.bind(this)} format="D.MM.YYYY, H:hh" locale="ru"/> : <input value={this.state.date_start} onChange={this.__changeDateStart.bind(this)} type="datetime-local" />}
                            </div>
                            <div className="m2date_input">
                                <label>По </label>
                                {!this.state.mobile ? <Datetime value={this.state.date_end} onChange={this.__changeDateEnd.bind(this)} format="D.MM.YYYY, H:hh" locale="ru"/> : <input value={this.state.date_end} onChange={this.__changeDateEnd.bind(this)} type="datetime-local" />}
                            </div>
                        </div>
                    </div>
                    {this.show_sources && <div className="m2filter_row m2filter_sources">{items_first}</div>}
                </form>
            </div>
        );
    }
}


export default Filter;


// WEBPACK FOOTER //
// ./src/components/Filter.js